import React, { PropsWithChildren } from 'react';

export interface IFeedback {
  feedbackMessage: string;
  submittedResponse: string;
  expectedResponse: string;
  responseWasCorrect: boolean;
  instructionsLink?: string;
}

interface IContext {
  feedback: IFeedback | undefined;
  setFeedback: (feedback: IFeedback | undefined) => void;
}

const TrainerFeedbackContext = React.createContext<
  IContext | Record<string, never>
>({});

const useTrainerFeedback = () => {
  const context = React.useContext(TrainerFeedbackContext);
  if (context === undefined) {
    throw new Error(
      'useTrainerFeedback must be used within the TrainerFeedbackContextProvider',
    );
  }
  return context;
};

const TrainerFeedbackContextProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [feedback, setFeedback] = React.useState<IFeedback | undefined>(
    undefined,
  );
  return (
    <TrainerFeedbackContext.Provider
      value={{
        feedback,
        setFeedback,
      }}>
      {children}
    </TrainerFeedbackContext.Provider>
  );
};

export { useTrainerFeedback, TrainerFeedbackContextProvider };
